import titleToSectionKey from '../../../titleToSectionKeyDict';
import { FormatTypes } from '../../../../../constants/templateDictionaries';

export default (data) => {
  const { userPreferences, formatType } = data;
  if (formatType && formatType === FormatTypes.COVER_LETTER) {
    const updateUserPreferences = {
      ...userPreferences,
      version: {
        number: 2,
        updated: true,
      },
    };

    return updateUserPreferences;
  }
  const {
    leftPane: { activeElement, unUsed, used },
  } = userPreferences;
  let updateActiveElement = activeElement;
  const { title, sectionKey: activeElementSectionKey } = activeElement;
  if (!activeElementSectionKey) {
    updateActiveElement = {
      ...updateActiveElement,
      sectionKey: titleToSectionKey[title],
    };
  }

  const updateUsedSection = used.map((use) => {
    const { title: useTitle, sectionKey: usedSectionKey } = use;
    if (!usedSectionKey) {
      return { ...use, sectionKey: titleToSectionKey[useTitle] };
    }
    return { ...use };
  });

  const updateUnUsedSection = unUsed.map((unUse) => {
    const { title: unUseTitle, sectionKey: unUseSectionKey } = unUse;
    if (!unUseSectionKey) {
      return { ...unUse, sectionKey: titleToSectionKey[unUseTitle] };
    }
    return unUse;
  });

  const updateUserPreferences = {
    ...userPreferences,
    leftPane: {
      ...userPreferences.leftPane,
      activeElement: { ...updateActiveElement },
      used: [...updateUsedSection],
      unUsed: [...updateUnUsedSection],
    },
    version: {
      number: 2,
      updated: true,
    },
  };

  return updateUserPreferences;
};
